var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.22,100.94l8.32-13m-33.28,5.38,13.79,10.32m-35.69,2.25,9.72-10.75m54.65-14.6a7,7,0,1,1-7-7.18A7.08,7.08,0,0,1,148.73,80.54Zm-62,31.4a7,7,0,1,1-7-7.18A7.08,7.08,0,0,1,86.77,111.94Zm46.63-5.16a7,7,0,1,1-7-7.18A7.08,7.08,0,0,1,133.4,106.78ZM106.7,90.85a7,7,0,1,1-7-7.17A7.09,7.09,0,0,1,106.7,90.85Zm61.86-33.67H47.22v79.35H168.56Zm13.71-12.64H33.5V149.18H182.27Zm12.33,124.3H21.17V149.18H194.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerGraph);
export default __webpack_public_path__ + "static/media/COMPUTER_GRAPH.97fa68986aef77cde77f20f8290bd0b5.svg";
export { ForwardRef as ReactComponent };